export type ThemeMode = "light" | "dark";

export function resolveThemeMode(
  themeParam: string | null | undefined
): ThemeMode {
  return themeParam?.trim().toLowerCase() === "dark" ? "dark" : "light";
}
